import { Feature, Point, GeometryCollection } from '@turf/helpers';

export function getCoordinates(feature: Feature): number[] {
  const coordinates = feature.geometry.hasOwnProperty('coordinates')
    ? (feature.geometry as Point).coordinates
    : ((feature.geometry as GeometryCollection).geometries[0] as Point).coordinates;

  return [coordinates[1], coordinates[0]];
}
